// extracted by mini-css-extract-plugin
export default {"cardContainer":"dashboardCard_cardContainer__o0frX","cardFill":"dashboardCard_cardFill__opFVp"};